import React from 'react';
import { Card, Table, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccMaintenance } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const MaintenanceIntegrationPanel: React.FC<Props> = ({ params }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useWccMaintenance(params);
  const d = data as {
    overdue?: Record<string, unknown>[];
    on_hold?: Record<string, unknown>[];
  };

  return (
    <Card id="maintenance" title="Maintenance integration" style={{ marginTop: 16 }} loading={isLoading}>
      <Table
        size="small"
        title={() => 'Overdue maintenance'}
        rowKey="workstation_id"
        dataSource={d?.overdue ?? []}
        onRow={() => ({ onClick: () => navigate('/mfg/workstations'), style: { cursor: 'pointer' } })}
        columns={[
          { title: 'Code', dataIndex: 'workstation_code' },
          { title: 'Name', dataIndex: 'workstation_name' },
          { title: 'Due', dataIndex: 'next_maintenance_date' },
          { title: 'Impact h', dataIndex: 'impact_hours' },
        ]}
        pagination={false}
        style={{ marginBottom: 16 }}
      />
      <Table
        size="small"
        title={() => 'On hold (maintenance / breakdown)'}
        rowKey="workstation_id"
        dataSource={d?.on_hold ?? []}
        columns={[
          { title: 'Name', dataIndex: 'workstation_name' },
          { title: 'Status', dataIndex: 'status', render: (s: string) => <Tag color="purple">{s}</Tag> },
        ]}
        pagination={false}
      />
    </Card>
  );
};

export default MaintenanceIntegrationPanel;
